import React from 'react';
import WorkExperienceItem from './WorkExperienceItem';

class WorkExperience extends React.Component {

  render() {
    return (
      <section id="experiences-section" className="experiences-section section">
        <h2 className="section-title">Work Experiences</h2>
        <div className="timeline">
          <WorkExperienceItem place={'Leidos'} location={'DC Area'} title={'Senior Software Engineer<br/>(Frontend)'} time={'Mar\'26 - Now'}>
            <p>
              Contractor on government project
            </p>
            <p>
              ReactJS, NodeJS, HTML, CSS, Bootstrap, JavaScript, Vite, Vitest, etc.
            </p>
          </WorkExperienceItem>

          <WorkExperienceItem place={'Leidos'} location={'DC Area'} title={'Senior Software Engineer<br/>(Backend)'} time={'Sep\'17 - Feb\'25'}>
            <p>
              Contractor on government project
            </p>
            <p>
              ReactJS, NodeJS, Postgres, HTML, CSS, Bootstrap, JavaScript, Express, etc.
            </p>
          </WorkExperienceItem>

          <WorkExperienceItem place={'Cycloware, LLC'} location={'Bethesda, MD'} title={'Senior Software Engineer'} time={'May\'15 - Aug\'17'}>
            <p>
              Cycloware, LLC is IT vendor for companies such as personadoctors.com,
              b12shot.com and other related websites.
              Specialization is online software for pharmacy management.
            </p>

            <p>Responsibility:</p>
            <ul>
              <li>Implemented new features for set of pharmacy applications</li>
              <li>Incorporated new UI design of public websites</li>
              <li>Containerization some services (Docker, Rancher)</li>
              <li>Migrated exist reporting system from DevExpress to JsReport</li>
              <li>Integrated the Slack, Glip and ServiceDesk Plus APIs</li>
              <li>Optimized performance</li>
              <li>Refactored and simplified the old codebase (old code is over-inherited)</li>
              <li>Deep research of migration from asp.net environment to “Node/React world”</li>
            </ul>

            <p>Environment:</p>
            <ul>
              <li>
                C#, ASP.NET MVC, RavenDB, MongoDB, SQL Server, HTML, CSS, Bootstrap,
                Angular2, React, JavaScript/TypeScript, jQuery, MassTransit, MSMQ, RabbitMQ
              </li>
            </ul>
          </WorkExperienceItem>

          <WorkExperienceItem place={'USTAS Technologies, Inc.'} location={'Rockville, MD'} title={'Senior Software Engineer'} time={'Dec\'08 - May\'15'}>
            <p>
              Contractor at The National Center for Biotechnology Information (NCBI).
              NCBI advances science and health by providing access
              to biomedical and genomic information.
            </p>

            <p>Responsibility:</p>
            <ul>
              <li>Created new version of Bookshelf Content Management System</li>
              <li>Incorporated new UI design into existing Manuscript Management system</li>
              <li>Developed high-quality code</li>
              <li>Designed reusable components by utilizing various standard frameworks</li>
              <li>
                Evaluated requirements and initial mock-ups;
                made technology recommendations that supported optimal construction,
                maintenance and performance
              </li>
              <li>Built and implemented easy-to-use the release/deployment process</li>
            </ul>

            <p>Environment:</p>
            <ul>
              <li>
                C#, .NET, Silverlight, SQL Server, MongoDB, Sharepoint,
                Windows Services, WCF, HTML, CSS, Bootstrap, JavaScript, XML/XSLT
              </li>
            </ul>
          </WorkExperienceItem>

          <WorkExperienceItem place={'EffectiveSoft, Ltd.'} location={'Minsk, BELARUS'} title={'Jr-Sr Software Engineer'} time={'Feb\'05 - Nov\'08'}>
            <p>
              Designed, developed, documented, refined and maintained web applications
              in a Microsoft-centric environment for company’s clients.
            </p>

            <p>Responsibility:</p>
            <ul>
              <li>Requirements and Business Analysis</li>
              <li>Code architecture and implementation</li>
              <li>
                Built and maintained web-based applications for Internet,
                Intranet and Extranet sites for company’s clients
              </li>
              <li>Implemented UI</li>
              <li>Migration of applications from Classic ASP to ASP.NET Framework</li>
            </ul>

            <p>Environment:</p>
            <ul>
              <li>ASP.NET, C#, VB, ADO.NET, Windows Forms, Classic ASP</li>
              <li>Dot Net Nuke CMS, Microsoft Content Management System</li>
              <li>HTML, CSS, JavaScript, VBScript</li>
            </ul>
          </WorkExperienceItem>

        </div>

      </section>
    );
  }
}

export default WorkExperience;



// WEBPACK FOOTER //
// ../components/Blocks/WorkExperience.jsx